import type { LatestOversightAssessmentDocumentOversightResultByDocumentIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetLatestOversightAssessmentDocumentAssessmentResultByDocumentIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetLatestOversightAssessmentDocumentAssessmentResultByDocumentIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetLatestOversightAssessmentDocumentAssessmentResultByDocumentIdArgs = {
  documentId: string;
};

export const useGetLatestOversightAssessmentDocumentAssessmentResultByDocumentId =
  createQueryHook<
    UseGetLatestOversightAssessmentDocumentAssessmentResultByDocumentIdArgs,
    LatestOversightAssessmentDocumentOversightResultByDocumentIdResponseRow[],
    GetLatestOversightAssessmentDocumentAssessmentResultByDocumentIdQuery
  >({
    trpcQueryOptions: (trpc, { documentId }) =>
      trpc.frontend.assessment.latestOversightAssessmentDocumentAssessmentResultByDocumentId.queryOptions(
        { documentId }
      ),
    mapTrpcDataToGraphQL: (data) => ({
      document_oversight_result: data,
    }),
    graphqlDocument:
      GetLatestOversightAssessmentDocumentAssessmentResultByDocumentIdDocument,
    graphqlVariables: ({ documentId }) => ({ DocumentId: documentId }),
  });
